let Timeline = require("./Timeline");
let TimelineBands = require("./TimelineBands");
let TimelineFever = require("./TimelineFever");
let TimelineAnnotations = require("./TimelineAnnotations");
let MetricUtil = require("../util/MetricUtil");

class MetricTimeline extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      detail: null
    };
  }

  render () {
    let {
      studyId,
      subjectId,
      channels,
      annotations,
      startTs,
      breakTs,
      stopTs,
      timezone
    } = this.props;

    let { detail } = this.state;

    let inBounds = function (ts, actClass) {
      if (/SLEEPING/.test(actClass)) {
        if (ts > breakTs + (mc.math.MILLIS_PER_HOUR * 12)) {
          return false;
        }
      }
      else {
        if (ts < breakTs) {
          return false;
        }
      }

      return true;
    };

    let feverData = function (type) {
      let channel = channels.find((c) => c.type === type);

      if (channel) {
        return channel.times.map(function (ts, i) {
          return {
            ts,
            value: channel.values[i]
          };
        }).filter(function (result, i) {
          return inBounds(result.ts, acts.values[i]);
        });
      }

      return [];
    };

    let acts = channels.find((c) => c.type === "activity") || {};

    let actData = (acts.times || []).map(function (ts, i) {
      let value = acts.values[i] || "UNKNOWN";
      let idx = inBounds(ts, value) ? 0 : 1;
      let color = MetricUtil.COLORS[value][idx];

      return {
        ts,
        color,
        value,
        label: tx(value)
      };
    });

    let onFollow = function (startTs) {
      mc.router.trigger("RECORDING_DATA_VIEW", { studyId, subjectId, startTs });
    };

    let onDetail = function (detail) {
      this.setState({ detail });
    };

    // TODO translate labels
    return (
      <div>
        <Timeline
          startTs={startTs}
          breakTs={breakTs}
          stopTs={stopTs}
          onFollow={onFollow}
          timezone={timezone}>
            <TimelineBands
              data={actData}
              icon="ACT_CLASS"
              label={"Activity"}/>
            <TimelineFever
              data={feverData("combined_act_count")}
              icon="ACT_COUNT"
              precision={0}
              label={"Activity Count"}/>
            <TimelineFever
              data={feverData("sleep_respiration")}
              icon="RESPIRATION"
              unit="br/min"
              precision={0}
              label={"Respiration"}/>
            <TimelineFever
              data={feverData("heart_rate")}
              icon="HR"
              unit="bpm"
              precision={0}
              label={"Heart Rate"}/>
            <TimelineFever
              data={feverData("frequency_hrv_ratio")}
              icon="HRV"
              unit="LF/HF"
              precision={1}
              label={"HRV (LF/HF)"}/>
            <TimelineFever
              data={feverData("hrv")}
              icon="HRV_RMSSD"
              unit="ms"
              precision={1}
              label={"HRV (RMSSD)"}/>
            <TimelineAnnotations
              data={annotations || []}
              icon="ANNOTATION"
              label={"Annotations"}
              onDetail={onDetail.bind(this)}/>
        </Timeline>
        {detail ? (
          <div className="rc-timeline-detail">
            <h2>{detail.title}</h2>
            <p>{detail.text}</p>
          </div>
        ) : null}
      </div>
    );
  }
}

module.exports = MetricTimeline;